var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_5660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99109 6.78516V9.323",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99109 1.33203V3.32981",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6526 8.65748V4.66193C12.6526 4.3087 12.5123 3.96994 12.2625 3.72017C12.0127 3.4704 11.674 3.33008 11.3208 3.33008H4.6615C4.30827 3.33008 3.96951 3.4704 3.71974 3.72017C3.46997 3.96994 3.32965 4.3087 3.32965 4.66193V8.65748",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9056 13.3187C13.622 12.1098 13.995 10.7283 13.9844 9.32317L8.53185 6.89986C8.36161 6.82423 8.1774 6.78516 7.99111 6.78516C7.80483 6.78516 7.62062 6.82423 7.45038 6.89986L1.99779 9.32317C1.96696 11.2168 2.63289 13.0559 3.86904 14.4907",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33185 13.9843C1.7314 14.3172 2.13096 14.6502 2.99666 14.6502C4.66147 14.6502 4.66147 13.3184 6.32629 13.3184C7.19199 13.3184 7.59154 13.6513 7.9911 13.9843C8.39065 14.3172 8.79021 14.6502 9.65591 14.6502C11.3207 14.6502 11.3207 13.3184 12.9855 13.3184C13.8512 13.3184 14.2508 13.6513 14.6503 13.9843",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_5660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9822,
    height: 15.9822,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.ea46ab487a4a058cb6f8c9a6a72ce6cb.svg";
export { ForwardRef as ReactComponent };